import { Modal, Table } from "react-bootstrap";
type props = {
    onClose: () => void;
    show: boolean
    data?: any
}
const CommonMembersList = ({ show, data, onClose }: props) => {
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{'Members List'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="table-card border-0 mb-4">
                    <Table className="table table-style" responsive hover  >
                        <thead>
                            <tr>
                                <th>Member name</th>
                                <th>Mobile</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((data: any, index: number) => (
                                <tr key={index}>
                                    <td>{data.name}</td>
                                    <td>{data.mobile}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default CommonMembersList;